<template>
    <div>
      <el-card>
        <!-- /* ---------------------------------- 表单查询 ---------------------------------- */ -->
        <el-row>
          <el-form :model="form" v-bind="formProps.form" :rules="{}">
            <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
              <range-date-picker @showDateTime="handleSetDateTime" />
              <!--          <el-date-picker type="datetimerange"-->
              <!--                          size="small"-->
              <!--                          range-separator="-"-->
              <!--                          v-model="formTime"-->
              <!--                          value-format="yyyy-MM-dd HH:mm:ss"-->
              <!--                          :default-time="['00:00:00', '23:59:59']"/>-->
            </el-form-item>
            <el-form-item :label="$t('withdraw.label.updateTime')">
              <el-date-picker type="datetimerange" size="small" range-separator="-" v-model="updateTimeRange"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
            </el-form-item>
            <el-form-item :label="$t('withdraw.label.merchatNo')" prop="merchatNo">
              <el-input v-model="form.merchatNo" />
            </el-form-item>
            <!--          <el-form-item :label="$t('withdraw.label.agentNo')" prop="agentNo">-->
            <!--            <el-input v-model="form.agentNo" />-->
            <!--          </el-form-item>-->
            <el-form-item :label="$t('withdraw.label.bankNo')" prop="bankNo">
              <el-input v-model="form.bankNo" />
            </el-form-item>
            <el-form-item :label="$t('withdraw.label.account')" prop="bankNo">
              <el-input v-model="form.account" />
            </el-form-item>
            <el-form-item :label="$t('withdraw.label.withdrawalNo')" prop="withdrawalNo">
              <el-input v-model="form.withdrawalNo" />
            </el-form-item>
            <el-form-item :label="$t('withdraw.label.withdrawalStatus')" prop="bankNo">
              <el-select v-model="form.withdrawalStatus">
                <el-option v-for="item in statusData.withdrawalStatus" :key="item.label" :label="item.label"
                  :value="item.value"></el-option>
                <el-option :label="$t('btns.emptyValue')" value=""></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="success" @click="handleEmpty()">{{ $t('btns.empty') }}
              </el-button>
              <el-button size="mini" type="primary" @click="handleSearch()">{{ $t('btns.search') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-row>

        <!-- /* ---------------------------------- 表格展示 ---------------------------------- */ -->
        <el-row>
          <div class="header-table">
            <ul class="list-table">
              <li class="li-table">
                <em class="label">
                  <span>
                    {{ $t('withdraw.label.withdrawalAmountTotal') }}
                  </span>
                  <span>：</span>
                </em>
                <span class="value">
                  {{ totalData.withdrawalAmountTotal | toThousands }}
                </span>
              </li>
              <li class="li-table">
                <em class="label">
                  <span>
                    {{ $t('withdraw.label.handlingFeeTotal') }}
                  </span>
                  <span>：</span>
                </em>
                <span class="value">
                  {{ totalData.handlingFeeTotal | toThousands }}
                </span>
              </li>
            </ul>

            <el-button v-if="tableList.length && permission.indexOf('export:withdrawOrder') > -1" @click="handleExport()">
              {{ $t('btns.export') }}
            </el-button>
          </div>

          <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }" :cell-style="showCellStyle" stripe>
            <el-table-column type="index" label="#"></el-table-column>
            <el-table-column :label="$t('clientmanage.table.merchantNo')" prop="merchatNo"></el-table-column>
            <el-table-column :label="$t('withdraw.label.merchatName')" prop="createAcct"/>
            <el-table-column :label="$t('withdraw.label.agentNo')">
              <template slot-scope="{ row }">
                {{ (row.account.includes('agent') || ( row.agentNo && (row.agentNo.length < 13) ))? $t('accountmanager.Agency') : '--' }} </template>
            </el-table-column>
            <el-table-column prop="withdrawalNo" :label="$t('withdraw.label.withdrawalNo')"></el-table-column>
            <el-table-column prop="actualTransferAmount" :label="$t('withdraw.label.actualTransferAmount')">
              <template slot-scope="{ row }">
                {{ row.actualTransferAmount | toThousands }}
              </template>
            </el-table-column>
            <el-table-column prop="bankName" :label="$t('withdraw.label.bankName')">
            </el-table-column>
            <el-table-column prop="bankNo" :label="$t('withdraw.label.bankNo')"> </el-table-column>
            <el-table-column prop="account" :label="$t('withdraw.label.account')"></el-table-column>
            <el-table-column prop="createTime" :label="$t('withdraw.label.createTime')">
              <template slot-scope="{ row }">
                {{ row.createTime | asDayjs }}
              </template>
            </el-table-column>
            <el-table-column width="200px" prop="updateTime" :label="$t('withdraw.label.updateTime')">
              <template slot-scope="{ row }">
                {{ row.updateTime | asDayjs }}
              </template>
            </el-table-column>
            <el-table-column prop="reviewer" :label="$t('withdraw.label.reviewer')"></el-table-column>
            <!--        <el-table-column prop="handlingFee" :label="$t('withdraw.label.handlingFee')"></el-table-column>-->
            <!--        <el-table-column prop="type" :label="$t('withdraw.label.type')"></el-table-column>-->
            <el-table-column prop="withdrawalNo" :label="$t('withdraw.label.withdrawalStatus')">
              <template slot-scope="{ row }">
                <template v-for="item in statusData.withdrawalStatus">
                  <el-tag :key="item.label" type="item.type" v-if="item.value == row.withdrawalStatus">
                    {{ item.label }}</el-tag>
                  <span :key="item.value" v-if="item.value == row.withdrawalStatus && row.withdrawalStatus === '3'">({{
                    row.updateAcct }})</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('withdraw.label.action')" width="150px"
              v-if="permission.indexOf(`review:withdraw`) > -1">
              <template slot-scope="{ row }">
                <template v-if="row.withdrawalStatus === '0'">
                  <el-button size="mini" type="primary" v-if="permission.indexOf(`review:withdraw`) > -1"
                    @click="handleReview(row, 3)">
                    {{ $t('status.error13') }}
                  </el-button>
                  <!--              <el-button-->
                  <!--                size="mini"-->
                  <!--                type="danger"-->
                  <!--                v-if="permission.indexOf(`review:withdraw`) > -1"-->
                  <!--                @click="handleReview(row, 1)">-->
                  <!--                {{ $t("btns.pass") }}-->
                  <!--              </el-button>-->
                  <!--              <el-button-->
                  <!--                size="mini"-->
                  <!--                type="primary"-->
                  <!--                v-if="permission.indexOf(`review:withdraw`) > -1"-->
                  <!--                @click="handleReview(row, 2)">-->
                  <!--                {{ $t("btns.reject") }}-->
                  <!--              </el-button>-->
                </template>
                <template v-else-if="row.withdrawalStatus === '3' && row.updateAcct === info.userName">
                  <el-button size="mini" type="danger" v-if="permission.indexOf(`review:withdraw`) > -1"
                    @click="handleReview(row, 1)">
                    {{ $t('btns.pass') }}
                  </el-button>
                  <el-button size="mini" type="primary" v-if="permission.indexOf(`review:withdraw`) > -1"
                    @click="handleReview(row, 2)">
                    {{ $t('btns.reject') }}
                  </el-button>
                </template>
                <el-tag type="info" v-else-if="row.withdrawalStatus !== '3'">
                  {{ $t('status.finish') }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />
      </el-card>
      <el-dialog :title="$t('btns.hint')" :close-on-click-modal="false" :show-close="false" :visible.sync="showLock"
        width="70%">
        <div style="display: flex;gap: 10px;">
          <div>
              <img :src="qrCodeUrl" width="300" height="300">
              <div class="input-box">
                  <el-input class="inputAmount" @input="handleInput"   @focus="handleFocus"    @blur="formatAmount" v-model.trim="amount" :placeholder="$t('accountmanager.inputtext')" clearable />
                  <el-input class="inputAmount" v-model="description" :placeholder="$t('transaction.label.remark')" />
                  <el-button type="primary" :disabled="!amount" size="medium" @click="updateQrCode(curRowData.id, amount, description)">{{ $t('orders.label.table.submitAmount') }}</el-button>
              </div>
          </div>
        <table style="width: 100%">
          <tr>
            <th style="width: 400px;">{{ $t('clientmanage.table.merchantNo') }}</th>
            <td>{{ curRowData ? curRowData.merchatNo : '' }}</td>
          </tr>
          <tr>
            <th style="width: 400px;">{{ $t('withdraw.label.bankName') }}</th>
            <td>{{ curRowData ? curRowData.bankName : '' }}</td>
          </tr>
          <tr>
            <th style="width: 400px;">{{ $t('withdraw.label.bankNo') }}</th>
            <td>{{ curRowData ? curRowData.bankNo : '' }}</td>
          </tr>
          <tr>
            <th style="width: 400px;">{{ $t('withdraw.label.account') }}</th>
            <td>{{ curRowData ? curRowData.account : '' }}</td>
          </tr>
          <tr>
            <th>{{ $t('withdraw.label.actualTransferAmount') }}</th>
            <td v-if="!curRowData">{{ '' }}</td>
            <td v-else>{{ curRowData.actualTransferAmount | toThousands }}</td>
          </tr>
          <tr>
            <th>{{ $t('withdraw.label.withdrawalNo') }}</th>
            <td v-if="!curRowData">{{ '' }}</td>
            <td v-else>{{ curRowData.withdrawalNo  }}</td>
          </tr>
        </table>
      </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="handleReview(curRowData, 1)" style="margin-right: 20px;">{{
            $t('btns.pass')
            }}</el-button>
          <el-button type="primary" @click="handleReview(curRowData, 2)">{{
            $t('btns.reject')
            }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>

  <script>
    import withdrawListApi from '@/api/withdrawlist';
    import {
      debounce
    } from 'lodash';
    import {
      isNumber,
      betweenLenNumber
    } from '@/utils/validate';
    import {
      mapGetters,
      mapState
    } from 'vuex';
    import RangeDatePicker from '../cuscom/range-date-picker.vue';

    export default {
      name: 'merchantWithdraw',
      components: {
        RangeDatePicker
      },
      data() {
        return {
          formTime: [],
          updateTimeRange: '',
          form: {},
          pagination: {
            current: 1,
            size: this.$defaultPaginationSize
          },

          tableData: {}, // 表格数据
          totalData: {},

          showLock: false,
          curRowData: null,
          amount: '',
          qrCodeUrl: '',
          description: ''
        };
      },
      computed: {
        ...mapState({
          info: ({
            user
          }) => user.info
        }),
        ...mapGetters(['permission', 'WITHDRAW_ORDER']),
        tableList() {
          // 表格list
          return this.tableData.list || [];
        },
        btnsTime() {
          return this.$t('orders.btns');
        },
        statusData() {
          return {
            withdrawalStatus: [{
              value: 2,
              type: 'danger',
              label: this.$t('status.error3')
            },
            {
              value: 1,
              type: 'success',
              label: this.$t('status.success3')
            },
            {
              value: 0,
              type: 'info',
              label: this.$t('status.doing1')
            },
            {
              value: 3,
              type: 'danger',
              label: this.$t('status.error13')
            }
            ],
            orderStatus: [{
              value: 0,
              type: 'danger',
              label: this.$t('status.error13')
            },
            {
              value: 1,
              type: '',
              label: this.$t('status.success1')
            },
            {
              value: 2,
              type: 'info',
              label: this.$t('status.errorafter')
            },
            {
              value: 3,
              type: 'success',
              label: this.$t('status.success')
            }
            ]
          };
        }
      },
      watch: {
        WITHDRAW_ORDER(n) {
          const _n = n || {};
          this.$notify.success(this.$t('tips.tip2', {
            money: _n.withdrawalAmount
          }));
          debounce(() => {
            this._handleSearch();
            this.getTotalData();
          }, 2000)();
        }
      },
      created() {
        this.init();
      },
      mounted() {
        this.getTableData();
        this.getTotalData();
      },
      methods: {
        init() {
          this.handleSearch = debounce(() => {
            this._handleSearch();
            this.getTotalData();
          }, 300);
          this.handleEmpty();
          /* ----------------------------- element -props ----------------------------- */
          this.formProps = {
            form: {
              ref: 'form',
              inline: true,
              size: 'small'
            },
            form1: {
              ref: 'form',
              inline: true,
              size: 'small',
              rules: {
                bankNo: [{
                  required: true,
                  message: this.$t('withdrawBank.rules.bankNo.required'),
                  trigger: 'blur'
                },
                {
                  validator: (rules, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t('withdrawBank.rules.bankNo.type')));
                    } else if (!betweenLenNumber(5, 30, value)) {
                      cb(new Error(this.$t('withdrawBank.rules.bankNo.length')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
                ]
              }
            }
          };
          /* ------------------------------- status 选择数据 ------------------------------ */
        },
        formatParams() {
          const [createTimeStart, createTimeEnd] = this.formTime;
          // if (!createTimeStart || !createTimeEnd) {
          //   // 若用户点击了时间表单的清空，则重新默认选择当天数据
          //   this.$refs.datePick.handleTime("today");
          // }
          return {
            ...Object.keys(this.form).reduce((acc, key) => {
              if (this.form[key] === 0 || this.form[key]) {
                acc[key] = this.form[key];
              }
              return acc;
            }, {}),
            createTimeStart: createTimeStart,
            createTimeEnd: createTimeEnd,
            updateTimeStart: typeof this.updateTimeRange === 'object' ? this.updateTimeRange[0] : '',
            updateTimeEnd: typeof this.updateTimeRange === 'object' ? this.updateTimeRange[1] : ''
          };
        },
        async getTableData() {
          const {
            data
          } = await withdrawListApi.getPage({
            data: this.formatParams(),
            params: this.pagination
          });
          if (data && data.code === 200) {
            this.tableData = data.data;
            console.log('当前用户名还是。。。', this.tableData);
          } else {
            this.$message.error(data.msg);
          }
          return 'finished';
        },
        async getTotalData() {
          const {
            data
          } = await withdrawListApi.getTotal(this.formatParams());
          if (data && data.code === 200) {
            this.totalData = data.data || {};
          } else {
            this.$message.error(data.msg);
          }
        },
        handleEmpty() {
          this.form = {
            merchatNo: '',
            agentNo: '',
            bankNo: '',
            account: '',
            withdrawalStatus: ''
          };
          this.updateTimeRange = '';
          // this.$nextTick(() => {
          //   this.$refs.datePick.handleTime("today");
          // });
        },
        async handleExport() {
          const {
            data
          } = await withdrawListApi.doExport(this.formatParams());
          if (data) {
            const BLOB = data;
            const fileReader = new FileReader();
            fileReader.readAsDataURL(BLOB);
            fileReader.onload = (event) => {
              // 处理load事件。该事件在读取操作完成时触发
              // 新建个下载的a标签，完成后移除。
              let a = document.createElement('a');
              a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
              a.href = event.target.result;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            };
          } else {
            this.$message.error(this.$t('status.error'));
          }
        },
        _handleSearch() {
          this.$refs.form.validate(async (valid) => {
            if (valid) {
              this.getTableData();
            }
          });
        },
        async handleReview(rowData, withdrawalStatus) {
          const {
            id
          } = rowData;
          const params = {
            id,
            withdrawalStatus
          };
          const service = this.$loading({});
          const {
            data
          } = await withdrawListApi.doReview(params);
          if (data && data.code === 200) {
            this.$message.success(this.$t('status.success'));
            this.getTableData()
              .then(() => {
                service.close();
                this.showLock = false;
                if (withdrawalStatus === 3) {
                  this.curRowData = rowData;
                  withdrawListApi.getQrCode({param:`?id=${id}&amount=0`}).then(res=>{
                      this.qrCodeUrl = res.data.data
                  })
                  this.showLock = true;
                }
              })
              .catch(() => service.close());
          } else {
            this.$message.error(data.msg);
            service.close();
          }
        },
        handleSetDateTime(dateArr) {
          this.formTime = dateArr;
        },
        showCellStyle({ row}) {
          let color = 'black';
          if (row.withdrawalStatus === '0') {
            color = 'blue';
          } else if (row.withdrawalStatus === '1') {
            color = 'green';
          } else if (row.withdrawalStatus === '2') {
            color = 'red';
          } else {
            color = '#E546F0';
          }
          return {
            textAlign: 'center',
            color: color
          };
        },
        updateQrCode(id, num, description) {
            const amount = num.replace(/,/g, ''); // 移除逗号
            withdrawListApi.getQrCode({param:`?id=${id}&amount=${amount}&description=${description}`}).then(res=>{
                this.qrCodeUrl = res.data.data
                })
            },

        // 聚焦时移除格式化
        handleFocus() {
          this.amount = this.amount.replace(/,/g, '');
        },

        // 失焦时格式化金额
        formatAmount() {
          const numberValue = parseInt(this.amount, 10);
        if (!isNaN(numberValue)) {
            // 使用本地化的格式化规则，确保使用逗号作为千位分隔符
            this.amount = numberValue.toLocaleString('en-US');
            }
        },

        // 限制输入为纯数字
        handleInput() {
        // 使用正则表达式过滤掉非数字字符
        this.amount = this.amount.replace(/[^\d]/g, '');
        }

      }
    };

  </script>

  <style lang="scss" scoped>
   /deep/ .el-button--success {
      background-color: rgb(0, 168, 84);
    }

    /deep/ .el-button--primary {
      background-color: #1964ca;
    }
    .header-table {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(0, 0, 0, 0.2);
      padding-right: 40px;

      .list-table {
        display: flex;
        list-style: none;

        li {
          display: flex;
          list-style: none;

          .label {
            font-style: normal;
          }

          .value {
            display: flex;
            list-style: none;
          }
        }

        li:nth-child(n + 2) {
          margin-left: 30px;
        }
      }

      .btn-table {
        margin-left: auto;
      }
    }

    table,
    th,
    td {
      border-collapse: collapse;
      border: 2px solid lightgray;
      text-align: center;
      font-size: 30px;
      font-weight: 400;
    }
    .input-box {
        .inputAmount {
            margin: 5px 0 ;
        }
    }

  </style>




// WEBPACK FOOTER //
// src/components/withdraw/index.vue